export const init = (): void => {
  // i18n은 메인 i18n에서 통합 관리
  console.log("User feature initialized");
};
